export const colorGroups = [
  {
    name: 'Universal Green',
    colors: [
      {
        value: '#65A518',
        name: '$color-hdi-universal-green',
        usage:
          'Colored areas, buttons, backgrounds, illustrations, button outlines, border, thin lines, tabs, icon states',
        avoid: 'Text, headlines, regular backgrounds',
      },
      {
        value: '#558817',
        name: '$color-hdi-universal-green-hover',
        usage: 'Hover effect buttons',
        avoid: 'Backgrounds, illustrations, headlines, text',
      },
    ],
  },
  {
    name: 'HDI Logo Green',
    colors: [
      {
        value: '#006729',
        name: '$color-hdi-logo-green',
        usage: 'Tags, accent colour, checkmark, form field states',
        avoid: 'Buttons, links, text',
      },
    ],
  },
  {
    name: 'Textlink/Turquoise Color',
    colors: [
      {
        value: '#008080',
        name: '$color-textlink-turquoise',
        usage: 'Textlinks on light background',
        avoid: 'Buttons, background, headlines',
      },
    ],
  },
  {
    name: 'HDI Light Blue',
    colors: [
      {
        value: '#00A3A8',
        name: '$color-hdi-light-blue',
        usage: 'Textlinks on dark background, Focus states',
        avoid: 'Buttons, headlines',
      },
    ],
  },
  {
    name: 'TBD Colors',
    colors: [
      { value: '#FF0075', name: '$color-tbd', usage: '', avoid: '' },
      { value: '#0065FF', name: '$color-tbd-blue', usage: '', avoid: '' },
    ],
    usage: 'To be done content, dummy data, lorem ipsum',
    avoid: 'In Production/live components.',
  },
  {
    name: 'Brand Colors',
    colors: [
      { value: '#E60018', name: '$color-hdi-red-error', usage: '', avoid: '' },
      { value: '#8D1429', name: '$color-hdi-dark-red', usage: '', avoid: '' },
      { value: '#00A3A8', name: '$color-hdi-blue', usage: '', avoid: '' },
      { value: '#003960', name: '$color-hdi-accent', usage: '', avoid: '' },
      {
        value: '#DB6301',
        name: '$color-brand-accent-highlight',
        usage: '',
        avoid: '',
      },
      {
        value: '#FF9900',
        name: '$color-brand-accent-highlight',
        usage: '',
        avoid: '',
      },
    ],
    usage: 'Error, success, important announcements, disrupter',
    avoid: 'Buttons, copy-text, headlines, border, forms',
  },
  {
    name: 'Black & White',
    colors: [
      { value: '#000000', name: '$color-black', usage: '', avoid: '' },
      { value: '#ffffff', name: '$color-white', usage: '', avoid: '' },
    ],
    usage:
      'Text, headlines, labels, buttons, links, system-icons, border, forms',
    avoid: '-',
  },
  {
    name: 'Neutrals',
    colors: [
      { value: '#282828', name: '$color-neutral-dark', usage: '', avoid: '' },
      { value: '#6C6F70', name: '$color-neutral-medium', usage: '', avoid: '' },
      { value: '#C6C7C8', name: '$color-neutral-light', usage: '', avoid: '' },
      {
        value: '#EEEEEF',
        name: '$color-neutral-lighter',
        usage: '',
        avoid: '',
      },
      {
        value: '#F9F9FA',
        name: '$color-neutral-lightest',
        usage: '',
        avoid: '',
      },
    ],
    usage:
      'Form elements, borders, tables, backgrounds, inactive conditions, separating elements',
    avoid: 'Copy, headlines, labels, icons, links',
  },
  {
    name: 'Color Gradations',
    colors: [
      {
        value: '#CCE1D4',
        name: '$color-gradation-success-lightest',
        usage: '',
        avoid: '',
      },
      {
        value: '#C1DBA3',
        name: '$color-gradation-success-light',
        usage: '',
        avoid: '',
      },
      {
        value: '#E0EDD1',
        name: '$color-gradation-success',
        usage: '',
        avoid: '',
      },
      {
        value: '#EFF6E7',
        name: '$color-gradation-success-dark',
        usage: '',
        avoid: '',
      },
      {
        value: '#FFC266',
        name: '$color-gradation-warning-light',
        usage: '',
        avoid: '',
      },
      {
        value: '#FFF4E5',
        name: '$color-gradation-warning',
        usage: '',
        avoid: '',
      },
      {
        value: '#99dadc',
        name: '$color-gradation-info-light',
        usage: '',
        avoid: '',
      },
      { value: '#e5f6f6', name: '$color-gradation-info', usage: '', avoid: '' },
      {
        value: '#FCE5E7',
        name: '$color-gradation-error-light',
        usage: '',
        avoid: '',
      },
    ],
    usage:
      'Backgrounds, error, success, important announcements, tables, tariff modules',
    avoid: 'Buttons, links, copy, border, headlines',
  },
];

export const spacers = [
  { name: '$spacing-01', value: '0.125rem', pixelValue: '2px' },
  { name: '$spacing-02', value: '0.25rem', pixelValue: '4px' },
  { name: '$spacing-03', value: '0.5rem', pixelValue: '8px' },
  { name: '$spacing-04', value: '0.75rem', pixelValue: '12px' },
  { name: '$spacing-05', value: '1rem', pixelValue: '16px' },
  { name: '$spacing-06', value: '1.5rem', pixelValue: '24px' },
  { name: '$spacing-07', value: '2rem', pixelValue: '32px' },
  { name: '$spacing-08', value: '2.5rem', pixelValue: '40px' },
  { name: '$spacing-09', value: '3rem', pixelValue: '48px' },
];

export const layoutScale = [
  { name: '$layout-01', value: '1rem', pixelValue: '16px' },
  { name: '$layout-02', value: '1.5rem', pixelValue: '24px' },
  { name: '$layout-03', value: '2rem', pixelValue: '32px' },
  { name: '$layout-04', value: '3rem', pixelValue: '48px' },
  { name: '$layout-05', value: '4rem', pixelValue: '64px' },
  { name: '$layout-06', value: '6rem', pixelValue: '96px' },
  { name: '$layout-07', value: '10rem', pixelValue: '160px' },
];

export const typography = [
  {
    group: 'Mixins',
    items: [
      {
        name: 'typography-xxl',
        desktop: {
          fontSize: '48px',
          lineHeight: '64px',
        },
        mobile: {
          fontSize: '24px',
          lineHeight: '32px',
        },
        usage: 'h1',
      },
      {
        name: 'typography-xl',
        desktop: {
          fontSize: '40px',
          lineHeight: '48px',
        },
        mobile: {
          fontSize: '20px',
          lineHeight: '24px',
        },
        usage: 'h2',
      },
      {
        name: 'typography-l',
        desktop: {
          fontSize: '32px',
          lineHeight: '40px',
        },
        mobile: {
          fontSize: '20px',
          lineHeight: '24px',
        },
        usage: 'h3',
      },
      {
        name: 'typography-m',
        desktop: {
          fontSize: '24px',
          lineHeight: '32px',
        },
        mobile: {
          fontSize: '20px',
          lineHeight: '24px',
        },
        usage: 'h4',
      },
      {
        name: 'typography-xs',
        desktop: {
          fontSize: '16px',
          lineHeight: '24px',
        },
        mobile: {
          fontSize: '14px',
          lineHeight: '16px',
        },
        usage: 'h6',
      },
      {
        name: 'typography-xxs',
        desktop: {
          fontSize: '14px',
          lineHeight: '16px',
        },
        mobile: {
          fontSize: '14px',
          lineHeight: '16px',
        },
      },
      {
        name: 'typography-p',
        desktop: {
          fontSize: '19px',
          lineHeight: '28px',
        },
        mobile: {
          fontSize: '16px',
          lineHeight: '24px',
        },
        usage: 'p, span',
      },
      {
        name: 'typography-copy',
        desktop: {
          fontSize: '19px',
          lineHeight: '32px',
        },
        mobile: {
          fontSize: '19px',
          lineHeight: '32px',
        },
        usage: 'copy',
      },
      {
        name: 'typography-copy-s',
        desktop: {
          fontSize: '16px',
          lineHeight: '24px',
        },
        mobile: {
          fontSize: '16px',
          lineHeight: '24px',
        },
        usage: 'copy-s',
      },
    ],
  },
  {
    group: 'Variables',
    subGroups: [
      {
        name: 'Font Sizes',
        items: [
          { name: '$font-size-xxl', value: '48px' },
          { name: '$font-size-xl', value: '40px' },
          { name: '$font-size-l', value: '32px' },
          { name: '$font-size-m', value: '24px' },
          { name: '$font-size-s', value: '20px' },
          { name: '$font-size-p', value: '19px' },
          { name: '$font-size-xs', value: '16px' },
          { name: '$font-size-xxs', value: '14px' },
          { name: '$font-size-xxl-mobile', value: '24px' },
          { name: '$font-size-xl-mobile', value: '20px' },
          { name: '$font-size-l-mobile', value: '20px' },
          { name: '$font-size-xs-mobile', value: '16px' },
          { name: '$font-size-xxs-mobile', value: '14px' },
        ],
      },
      {
        name: 'Line Heights',
        items: [
          { name: '$line-height-xxl', value: '64px' },
          { name: '$line-height-xl', value: '48px' },
          { name: '$line-height-l', value: '40px' },
          { name: '$line-height-m', value: '32px' },
          { name: '$line-height-s', value: '28px' },
          { name: '$line-height-xs', value: '24px' },
          { name: '$line-height-xxs', value: '16px' },
          { name: '$line-height-xxl-mobile', value: '32px' },
          { name: '$line-height-l-mobile', value: '24px' },
          { name: '$line-height-xs-mobile', value: '20px' },
          { name: '$line-height-xxs-mobile', value: '16px' },
        ],
      },
    ],
  },
];
